export default "__VITE_ASSET__eb0e1f24__"